<template>
  <div></div>
</template>

<script>

import mapboxgl from 'mapbox-gl';
import { uniqBy, get } from 'lodash';

export default {
  name: 'Mapbox',
  components: {
    'map-box': mapboxgl,
  },
  mounted() {
  },
  props: {
    'map-container': {
      type: String,
      default: 'map',
      require: true,
    },
    'all-data': {
      type: Object,
    },
    zoom: {
      type: Number,
      default: 13,
      require: false,
    },
  },
  watch: {
    allData(newData) {
      if (newData.center[0] === 0) {
        return;
      }
      this.loadData();
    },
  },
  methods: {
    loadData() {
      const { mapContainer } = this;
      mapboxgl.accessToken = 'pk.eyJ1IjoibWR3aWt5cmFtYSIsImEiOiJjanQ1ZnMyZ3MwNXloNDRsZnpndDkwZTM3In0.hDCVag3KpnoUJgVBtOGvHA';
      const map = new mapboxgl.Map({
        container: mapContainer, // container id
        style: 'mapbox://styles/mapbox/light-v9', // stylesheet location
        center: [this.allData.coordinates[1], this.allData.coordinates[0]],
        zoom: 12, // starting zoom
      });

      //  marker
      const markerFeatures = uniqBy([
        this.allData.origin,
        ...this.allData.orders.map(o => o.destination),
      ].map(location => ({
        type: 'Feature',
        geometry: location.geometry,
        properties: {
          name: location.name,
        },
      })), 'properties.name');

      // const point = this.allData.orders.length;
      // const markerCoord = this.allData.orders.map(o => o.destination).map(markerCoordinate => ({
      //   geometry: markerCoordinate.geometry,
      // }));

      const dataOrder = uniqBy(this.allData.orders.map((order) => {
        // const point = this.allData.orders.length;
        const coordinates = get(order, 'destination.geometry.coordinates');
        return {
          type: 'Feature',
          properties: {
            number: 1,
            orderId: order.id,
          },
          geometry: {
            type: 'Point',
            coordinates,
          },
        };
      }), 'properties.orderId');

      const pinn = {
        type: 'FeatureCollection',
        features: dataOrder,
      };

      pinn.features.forEach((marker) => {
        const el = document.createElement('div');
        const elSpan = document.createElement('span');
        elSpan.textContent = marker.properties.number;
        elSpan.className = 'number';
        el.appendChild(elSpan);
        // // add marker to map
        new mapboxgl.Marker(el)
          .setLngLat(marker.geometry.coordinates)
          .addTo(map);
      });
      // linestring
      const lineFeatures = uniqBy(this.allData.orders.map((order) => {
        const coordinates = get(order, 'direction.geo_poly.coordinates');

        return {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates,
          },
          properties: {
            orderId: order.id,
          },
        };
      }), 'properties.orderId');

      map.on('load', () => {
        // Linestring
        map.addLayer({
          id: 'LineString',
          type: 'line',
          source: {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: lineFeatures,
            },
          },
          layout: {
            'line-join': 'round',
            'line-cap': 'round',
          },
          paint: {
            'line-color': '#BF93E4',
            'line-width': 5,
          },
        });

        // Marker
        map.addLayer({
          id: 'points',
          type: 'symbol',
          source: {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: markerFeatures,
            },
          },
          layout: {
            'icon-image': 'marker-15',
            'icon-size': 1.8,
            'text-field': '{name}',
            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
            'text-offset': [0, 0.6],
            'text-anchor': 'top',
          },
        });

        map.addControl(new mapboxgl.NavigationControl({ showCompass: false }));
      });

      return map;
    },
  },
};
</script>

<style scoped lang='scss'>
@import "~mapbox-gl/dist/mapbox-gl.css";
#map {
  position:absolute;
  top:20%;
  bottom:0;
  width:100%;
}
</style>
<style>
.number{
  position: relative;
  bottom: -1px;
  left: 15px;
  display: block;
  font-size: 13pt;
  color: whitesmoke;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Mapbox.vue